<template>
  <EnhancedDocViewer :facility="facility" :client="client" :docs="(messages.patientDoc ? messages.patientDoc : activeDocs)" :key="(messages.patientDoc ? messages.patientDoc : activeDocs[0].dockey)" height="100vh" />
</template>

<script>
import broadcast from "../mixins/windowSync.js";
import EnhancedDocViewer from "../components/EnhancedDocViewer.vue";

export default {
  name: "EnahncedPopoutPDFViewer",
  mixins: [broadcast],
  components: {EnhancedDocViewer},
  data() {
    return {
      facility: null,
      client:null,
      activeDocs:null,
      imgfile: null,
    };
  },
  watch: {
    //   messages:{
    //     handler: function (newData) {
    //       // console.log("NEW MESSAGE");
    //       // console.log(JSON.stringify(newData));
    //       this.activeDocs = newData.patientDoc;
    //     },
    //     deep: true,
    //   },
    //   messages(newData){
    //     // console.log("NEW MESSAGE");
    //     // console.log(JSON.stringify(newData));
    //     this.activeDocs = newData.patientDoc;
    //   }
  },
  methods: {
    b64er() {
      const reader = new FileReader();
      reader.readAsDataURL(require("../assets/" + this.fname));
      reader.onload = () => {
        //// console.log(reader.result);
        this.imgfile = reader.result;
      };
    },
    closingPopout(){
        this.endBroadcast("patientDoc");
    },
  },
  computed: {},
  created() {
    this.facility = this.$route.query.facility;
    this.client = this.$route.query.client;
    this.activeDocs = JSON.parse(this.$route.query.activeDocs);
    // console.log("CREATED " + this.activeDocs.length);
    window.addEventListener('beforeunload', this.closeWindow)
  },
  mounted() {
    this.startBroadcast("patientDoc");
    // console.log("MOUNTED " + this.activeDocs.length);
  },
};
</script>

<style scoped>
    html, body
    {
        height: 100%;
    }
</style>
